import { Button, Input } from 'antd';
import { Separator } from 'components/common/Common';
import Loader from 'components/public/Loader';

import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from 'react';

import HeaderMeta from 'components/headerMeta/HeaderMeta';
import { useHistory, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { getBlogDetails } from 'services';
import { formatDateHandle, roll } from 'untils/auth';
import '../../assets/style/itemStyle/blog.scss';
import Footer from '../../components/layout/Footer';

import useLockBody from 'untils/hook/useLockBody';
import BlogAction from './components/BlogAction';

const shareIcons = [
  { className: 'icon-facebook', name: 'facebook' },
  { className: 'icon-twitter', name: 'twitter' },
  { className: 'icon-linkedin', name: 'linkedin' },
  { className: 'icon-link', name: 'link' },
];

const BlogDetails = (props) => {
  const inputRef = useRef();
  const [details, setDetails] = useState({});
  const [recommendList, setRecommendList] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const linkValue = window.location.href;
  let params = useParams();
  let history = useHistory();

  // prevent body from scrolling
  useLockBody(open);

  useEffect(() => {
    const controller = new AbortController();

    const getBlogDetailsData = async () => {
      const blogId = params.id;
      if (blogId) {
        try {
          setLoading(true);
          const res = await getBlogDetails(blogId, { signal: controller.signal });
          if (res.code && res.data) {
            setDetails({ ...res.data, Date: formatDateHandle(res.data.Date) });
            setRecommendList(res.data.link);
          } else {
            history.push('/blog');
          }
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      }
      roll(0);
    };

    getBlogDetailsData();

    return () => {
      controller.abort();
    };
  }, [params.id]);

  //打开分享弹窗
  const openShareLinkHandle = () => {
    setOpen(true);
    setTimeout(() => {
      inputRef.current.select();
    }, 10);
  };

  //关闭分享弹窗
  const closeShareLinkHandle = () => {
    setOpen(false);
  };

  //copy分享链接
  const copyLinkHandle = () => {
    navigator.clipboard.writeText(linkValue);
    setOpen(false);
  };

  // 分享
  const shareHandle = (e) => {
    e.preventDefault();
    const type = e.target.name || e.target.getAttribute('name');
    const socialLink = {
      facebook: `https://www.facebook.com/dialog/share?app_id=${process.env.REACT_APP_FACEBOOK_APP_ID}&href=${linkValue}`,
      twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(linkValue)}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${linkValue}`,
    };
    const pageURL = socialLink[type] || '/';
    if (type === 'link') {
      return openShareLinkHandle();
    }
    window.open(
      `${pageURL}`,
      `${type}`,
      'height=800, width=640, top=0, left=0, toolbar=no, menubar=no, scrollbars=no,   resizable=no, location=no, status=no'
    );
  };

  return (
    <div className="blog-details-container">
      <HeaderMeta type="common" />
      {loading ? (
        <Loader />
      ) : (
        <>
          {details?.Content ? (
            <>
              <div className="blog-content">
                <div className="w1100 content">
                  <button
                    className="bg-image back-img"
                    onClick={() => {
                      props.history.push('/blog');
                    }}
                    aria-label="Back to blog list"
                  ></button>
                  <p className="date">
                    {dayjs(new Date(details.Date)).format('MMM DD, YYYY')}
                    <span className="author">{details.Author}</span>
                  </p>
                  <h1 className="title">{details.Title}</h1>
                  <div
                    className="blog-details"
                    dangerouslySetInnerHTML={{ __html: details.Content }}
                    id="contentDetail"
                  />
                  <div className="blog-details">
                    <BlogAction />

                    <Separator />
                    <p>
                      Your next private jet charter flight starts with Airacer. Our team is ready
                      24/7 to help with every detail.
                    </p>
                    <p>
                      Frequent flyer? Discover our <Link to="/membership">Membership Program</Link>,
                      designed to give you exclusive perks like a dedicated concierge, exclusive
                      discounts, and priority access to empty leg flights.
                    </p>
                  </div>

                  <div className="blog-details-bottom">
                    {details.Tags && (
                      <ul className="article-tag">
                        {details.Tags.map((item) => {
                          return (
                            <li key={item.Name}>
                              <Link
                                to={{
                                  pathname: `/blog`,
                                  search: `?category=${item.Url}`,
                                }}
                              >
                                {item.Name}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                    <div className="article-share">
                      <ul>
                        {shareIcons.map((share) => {
                          return (
                            <li
                              key={share.name}
                              className={share.className}
                              name={share.name}
                              onClick={shareHandle}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                  shareHandle(e);
                                }
                              }}
                              role="button"
                              tabIndex={0}
                              aria-label={`Share on ${share.name}`}
                            />
                          );
                        })}
                      </ul>
                      <span>{details.PageViews} views</span>
                    </div>

                    <div className={`link-popup-box ${open && 'active'}`}>
                      <div className="popup-mask"></div>
                      <div className="link-popup">
                        <div className="public-title">
                          <img src="/imgs/svg/form-tit.svg" alt="title icon" />
                          <span>Share Link</span>
                        </div>
                        <div className="input-box">
                          <Input
                            value={linkValue}
                            readOnly="readonly"
                            ref={inputRef}
                            id="link-input"
                            onClick={() => {
                              inputRef.current.select();
                            }}
                          />
                        </div>
                        <div className="share-btn">
                          <Button onClick={closeShareLinkHandle}>Cancel</Button>
                          <Button onClick={copyLinkHandle}>Copy Link</Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {recommendList && (
                <div className="blog-relevant-recommend">
                  <div className="title">
                    <span>Recommended Posts</span>
                    <a href="/blog">
                      <span>See All</span>
                    </a>
                  </div>
                  <ul className="blog-relevant">
                    {recommendList.map((item) => {
                      return (
                        <li key={item.blogId}>
                          <Link to={encodeURIComponent(`${item.url || item.blogId}`)}>
                            <img
                              src={`${process.env.REACT_APP_RESOURCE_URL}/${item.image}`}
                              alt="blog propaganda"
                            />
                            <div className="blog-text">
                              <h3 className="title">
                                <span>{item.title}</span>
                              </h3>
                              <p className="describe">{item.describe}</p>
                              <p className="date">
                                {dayjs(new Date(item.date)).format('MMM DD, YYYY')}
                              </p>
                            </div>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </>
          ) : (
            <div className="not-found w1100">
              <img
                src={require('../../assets/imgs/webp/blog-noData.webp').default}
                alt="nodata img"
              />
              <p>The blog was not found</p>
            </div>
          )}
        </>
      )}
      <Footer></Footer>
    </div>
  );
};

export default BlogDetails;
